import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { DashboardService} from "../../services/dashboard/dashboard.service";
import {CommonService} from "../../services/common/common.service"
import { FormControl,FormGroup,FormBuilder,FormArray,ValidatorFn} from "@angular/forms";
@Component({
    selector: 'export-group-viewer',
    templateUrl: 'group-export-dialog.component.html',
    styleUrls: ["group-export-dialog.component.scss"],
    encapsulation: ViewEncapsulation.None
})

export class ExportGroupViewerDialog implements OnInit {
    exportTypeN :string;
    dashboardName : string;
    url:string;
    showDownloadDiv:boolean = false;
    exportName:string;
    headersContant =[
      { id:"widgetId",value:"Widget Id" },
      { id:"widgetName",value:"Widget Name" },
      { id:"kpiGroup",value:"KPI Group" },
      { id:"kpi",value:"KPI" },
      { id:"date",value:"Date" },
      { id:"dateFrom",value:"DateFrom" },
      { id:"value",value:"Value" }
     ];
    headersForm: FormGroup;


    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private fb:FormBuilder,
        private dialogRef: MatDialogRef<ExportGroupViewerDialog>
      ) { 
        this.exportTypeN = data.exportTypeN;
        this.dashboardName = data.dashboardName;
        this.url = data.url;
        this.exportName = data.exportTypeN;
        
      }
    
  ngOnInit() {
    // this.loadDoc()  
    this.createGroupList();
    this.exportName = this.exportName.charAt(0).toUpperCase() + this.exportName.slice(1) ;
    //console.log(this.exportName);
  }

  createGroupList(){
    const controls = this.headersContant.map(c => new FormControl(true));
    this.headersForm = this.fb.group({
        headersList: this.fb.array(controls,minSelectedCheckboxes(1))
    });
  }

  loadDoc(){
    this.showDownloadDiv = true;
    this.dashboardService.downloadReport(this.url).subscribe( (res) => {
      var  blob = new Blob([res], {type: res.type});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
        var fileExt = this.exportTypeN === "excel" ? ".xlsx" :  ".csv"; 
      var fileName = this.dashboardName + fileExt;
      link.download = fileName;
      link.click();
      this.dialogRef.close();
  },(err)=>{
    this.dialogRef.close();
    this.commonService.openSnackBar("Failed while generating " + this.exportTypeN + " report", "");
  });
}


onHeadersSubmit():void{
  let selectedHeaders = this.headersForm.value.headersList
  .map((v, i) => v ? this.headersContant[i].id : null)
  .filter(v => v !== null);  
  this.url += "&selectedh=" + selectedHeaders;
  this.loadDoc();
}
}
function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      // get a list of checkbox values (boolean)
      .map(control => control.value)
      // total up the number of checked checkboxes
      .reduce((prev, next) => next ? prev + next : prev, 0);

    // if the total is not greater than the minimum, return the error message
    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/export/groupexport/group-export-dialog.component.ts